function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 0C9.63021 0 0 9.63021 0 21.5C0 33.3698 9.63021 43 21.5 43C33.3698 43 43 33.3698 43 21.5C43 9.63021 33.3698 0 21.5 0ZM32.5635 16.3042L19.9323 28.9802C19.5292 29.3833 18.9469 29.6521 18.3646 29.6521C17.7823 29.6521 17.2 29.4281 16.7969 28.9802L10.4365 22.6198C9.54062 21.724 9.54062 20.3354 10.4365 19.4396C11.3323 18.5438 12.7208 18.5438 13.6167 19.4396L18.3646 24.1875L29.4281 13.124C30.324 12.2281 31.7125 12.2281 32.6083 13.124C33.4594 14.0198 33.4594 15.4083 32.5635 16.3042Z",
  fill: "#61BCE1"
});

var SvgChecked = function SvgChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked.f57418b8.svg";
export { ForwardRef as ReactComponent };